define('NSeComm.CPQWebstoreCurrency.Main', [

], function NSeCommCPQWebstoreCurrencyMain(

) {
    'use strict';

    /* global vcpq */
    var DEFAULT_CURRENCY_CODE = 'USD';

    var cpqSendOptions = function cpqSendOptions(cpqOptions) {
        if (vcpq) {
            vcpq.addMessageListener('cpq-ready', function cpqReady() {
                // console.log('CPQ : ready', arguments, cpqOptions);
                vcpq.postMessage('cpq-options', cpqOptions);
            });
        }
        return Boolean(vcpq);
    };

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var session = container.getComponent('Environment').getSession();

            var cpqSendCurrency = function cpqSendCurrency() {
                try {
                    if (layout && !layout.cpqReady && session && session.currency) {
                        layout.cpqReady = cpqSendOptions({
                            currency: session.currency.code || DEFAULT_CURRENCY_CODE
                        });
                    }
                } catch (e) {
                    console.warn('CPQ : ready', e); // eslint-disable-line no-console
                }
            };

            if (layout) {
                // Init flag
                layout.cpqReady = false;
                // 1st attempt
                cpqSendCurrency();
                // 2nd attempt
                layout.on('beforeShowContent', cpqSendCurrency);
                // 3rd attempt
                layout.on('afterShowContent', cpqSendCurrency);
            }
        }
    };
});
